import React from "react"
import { graphql } from "gatsby"
import PodcastEpisode from "../components/podcast-episode"
import Layout from "../components/layout"
import SEO from "../components/seo"

export const query = graphql`
	query PodcastEpisodeTemplateQuery($id: String!) {
		podcast: sanityPodcast(id: { eq: $id }) {
			id
			publishedAt
			categories {
				_id
				title
			}
			title
			slug {
				current
			}
			_rawExcerpt(resolveReferences: { maxDepth: 5 })
			anchorFmLink
			# _rawBody(resolveReferences: { maxDepth: 5 })
		}
	}
`

const PodcastEpisodeTemplate = (props) => {
	const { data } = props
	const podcast = data && data.podcast
	return (
		<Layout>
			<SEO title={podcast.title} />
			{podcast && <PodcastEpisode {...podcast} />}
		</Layout>
	)
}

export default PodcastEpisodeTemplate
